import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import PaidUsersFeatureTable from './PaidUsersFeatureTable';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PaidUsersModal = ({
  productLevel,
  productLine,
  onCloseClick
}) => {
  return /*#__PURE__*/_jsxs(Modal, {
    width: 700,
    use: "conversational",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h2",
        typography: "heading-600",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.seatsPicker.howMany"
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onCloseClick
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        justifyContent: "center",
        children: [/*#__PURE__*/_jsx(Text, {
          marginBlockEnd: "500",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricingPage.seatsPicker.paidUsersModal.primaryDifferenceSubtext"
          })
        }), /*#__PURE__*/_jsx(PaidUsersFeatureTable, {
          productLine: productLine,
          productLevel: productLevel
        })]
      })
    })]
  });
};
export default PaidUsersModal;